export const brandName = 'Engage';
export const brandLogo = 'equifax.png';
export const idProp = 'efxId';
export const showProvidedBy = true;